import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#4a90e2";
function NANO({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M18.713 8.25c-.644 0-1.188.52-1.188 1.187 0 .94-.148 1.188-1.188 1.188h-.099a1.16 1.16 0 00-1.063 1.162v.025c0 .915-.173 1.138-1.187 1.138-.05 0-.1 0-.124.025-.594.074-1.064.569-1.064 1.162 0 .644.52 1.188 1.188 1.188.618 0 1.137-.495 1.162-1.088v-.1c0-.84.272-1.162 1.162-1.187h.025c.619 0 1.139-.495 1.163-1.113v-.075c0-.865.272-1.187 1.188-1.187.643 0 1.187-.519 1.187-1.187 0-.618-.52-1.138-1.163-1.138m-6.977 2.374a1.2 1.2 0 011.089 1.139c0 .668-.52 1.187-1.188 1.187a1.19 1.19 0 01-1.187-1.187c0-.841-.272-1.162-1.187-1.162s-1.188.32-1.188 1.187v.074c-.024.593-.544 1.088-1.162 1.088a1.19 1.19 0 01-1.188-1.187c0-.619.47-1.114 1.064-1.162h.099c1.039 0 1.187-.223 1.187-1.163a1.188 1.188 0 012.375 0c0 .94.148 1.186 1.187 1.186zm-7.174 4.7a1.187 1.187 0 110-2.373 1.187 1.187 0 010 2.374" /></Svg>;
}
NANO.DefaultColor = DefaultColor;
export default NANO;